import { Box, Card, Stack, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useEffect, useRef, useState } from "react";
import { Editor } from "@tinymce/tinymce-react";
// Import TinyMCE to load it into global scope
import "tinymce/tinymce";
// Import TinyMCE plugins and themes
import "tinymce/themes/silver";
import "tinymce/icons/default";
import "tinymce/models/dom";
// Import plugins
import "tinymce/plugins/lists";
import "tinymce/plugins/link";
import "tinymce/plugins/image";
import "tinymce/plugins/table";
import "tinymce/plugins/help";
import { axiosInstance } from "../../utils/networking";
import { editorToolbarInit } from "../../utils/editorToolbar";

const EmailViewer = (props: any) => {
  const editorRef = useRef(null);
  const [email, setEmail] = useState({
    htmlContent: "",
    attachments: [],
  });

  useEffect(() => {
    if (props.activity) {
      axiosInstance
        .get(`/email?email_id=${props.activity.email_id}`)
        .then((res) => {
          if (res.status === 200) {
            setEmail(res.data.email);
          } else {
            console.log("API Error");
          }
        });
    }
  }, [props.activity]);

  return (
    <>
      <Box
        sx={{
          textAlign: "center",
          backgroundColor: "#9E1F63FF",
          padding: "3px",
          margin: 0,
          color: "white",
          borderRadius: "5px 5px 0 0",
        }}
      >
        <Typography sx={{ display: "inline-block" }} variant="h4">
          {props.activity.activity_type}
        </Typography>
        <Box
          sx={{ display: "inline", float: "right", cursor: "pointer" }}
          onClick={() => {
            props.setEditorOpen(false);
          }}
        >
          <CloseIcon sx={{ fontSize: 40 }}></CloseIcon>
        </Box>
      </Box>

      <Box>
        {email.attachments && email.attachments.length > 0 && (
          <Stack sx={{ margin: 0, marginLeft: "10px" }} spacing={0.5}>
            {email.attachments.map((attachment: any, index: number) => {
              return (
                <Card
                  key={index}
                  sx={{ backgroundColor: "#f1f1f1", maxWidth: "fit-content" }}
                >
                  <a
                    href={attachment.download}
                    target="_blank"
                    style={{ cursor: "pointer" }}
                  >
                    {attachment.name}
                  </a>
                </Card>
              );
            })}
          </Stack>
        )}
        <Box
          sx={{
            margin: "10px",
            border: "solid 1px #c4c4c4",
            borderRadius: "0 0 10px 10px",
            overflow: "auto",
            height: "500px",
          }}
        >
          <Editor
            //@ts-ignore
            onInit={(evt, editor) => (editorRef.current = editor)}
            initialValue={email.htmlContent}
            init={{
              forced_root_block: "",
              skin_url: "/skins/ui/oxide",
              content_css: "/skins/content/default/content.css",
              height: 500,
              menubar: false,
              toolbar:
                "undo redo | formatselect | " +
                "bold italic backcolor | alignleft aligncenter " +
                "alignright alignjustify | bullist numlist outdent indent | " +
                "removeformat | help",
              ...editorToolbarInit,
              content_style:
                "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
              relative_urls: false,
              remove_script_host: false,
            }}
          />
        </Box>
      </Box>
    </>
  );
};

export default EmailViewer;
